import { useEffect } from "react";
import { auth } from "marvin-auth-kit";
import { useNavigate } from "react-router-dom";

export const LogoutPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    auth.logout();

    navigate("../login");
  }, [navigate]);

  return null;
};
